module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "HLS_Damage_Probability_Cover_Image_FL.6d25b02c.jpg";